import script from "./CreateForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateForm.vue?vue&type=script&setup=true&lang=js"

import "./CreateForm.vue?vue&type=style&index=0&id=08a2b488&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08a2b488"]])

export default __exports__